export const registryUrl = 'https://endoflife.date/api';
export const datasource = 'endoflife-date';
